<script lang="ts">
	import { env } from "$lib/env.client";
	import { onMount } from "svelte";

	onMount(async () => {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("js", new Date());
		gtag("config", env.PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID);
		var s = document.createElement("script");
		s.src = `https://www.googletagmanager.com/gtag/js?id=${env.PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID}`;
		document.head.append(s);
	});
</script>
